// @flow
import Href from "../models/href/Href";
import CaseSearchModel from "../models/search/CaseSearchModel";

import { useModularUIBasic } from "./useModularUIBasic";

import type { HookOptions } from "./useModularUIBasic";

/**
 */
export const useQuicksearch = (
  href: string | Href,
  options?: HookOptions,
): CaseSearchModel | null =>
  useModularUIBasic("quicksearch", href, {
    expectedModels: ["CaseSearch"],
    targetModel: CaseSearchModel,
    ...options,
  });

/**
 */
export const useSearch = (
  href: string | Href,
  options?: HookOptions,
): CaseSearchModel | null =>
  useModularUIBasic("search", href, {
    expectedModels: ["CaseSearch"],
    targetModel: CaseSearchModel,
    ...options,
  });
